import { MaskedHeading, Reveal } from "@/components/primitives";

export default function PageHeader({ eyebrow, titleLines, description }) {
    return (
        <section className="relative overflow-hidden border-b border-border pt-36 pb-16 md:pt-44 md:pb-20">
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0 -z-10 opacity-[0.3] dark:opacity-15"
                style={{
                    backgroundImage:
                        "linear-gradient(hsl(var(--border)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--border)) 1px, transparent 1px)",
                    backgroundSize: "64px 64px",
                    maskImage:
                        "radial-gradient(ellipse 70% 60% at 30% 0%, black, transparent 75%)",
                }}
            />
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.22em] text-muted-foreground">
                    <span className="h-px w-6 bg-navy/60" />
                    {eyebrow}
                </span>
                <MaskedHeading
                    as="h1"
                    lines={titleLines}
                    delay={0.05}
                    className="mt-6 max-w-4xl text-balance text-5xl font-extrabold leading-[1.05] tracking-tight md:text-6xl lg:text-7xl"
                />
                {description && (
                    <Reveal delay={0.4} className="mt-7 max-w-2xl">
                        <p className="text-lg leading-relaxed text-muted-foreground">
                            {description}
                        </p>
                    </Reveal>
                )}
            </div>
        </section>
    );
}
